






















import Vue from 'vue'
import {api} from '../singleton'
export default Vue.extend({
  data: () => ({
    account: '',
    password: '',
    failed: false,
  }),
  methods: {
    submit () {
      this.failed = false
      api.reqMan.login({account: this.account, password: this.password}).then((res) => {
        console.log('LOGIN result === ', res)
      }).catch(() => {
        this.failed = true
      })
    }
  },
  mounted () {
    const passwd = this.$refs.passwd as HTMLElement
    const account = this.$refs.account as HTMLElement
    passwd.focus()
    this.$nextTick(() => {
      account.focus()
    })
  }
})
